module.exports = __webpack_public_path__ + "static/fish-20-987bc8b5d83ab4cc535d485de83a3efe.jpg";